/* attempt to write a new dirty checker for applying on a root model */
var originalRootKoModels = {};


//used on properties to be ignored if values change, in cases of things not passed to server or for UI display purposes only
ko.extenders.ignoreDirty = function (target, ignoreDirty) {

    var ignore = ignoreDirty;
    target.ignoringDirty = function () {
        return ignore;
    }

    return target;
};

//used for observable arrays if simply changing the order of the array is for display purposes and doesn't count as an actual change
//the sortExpression gets applied to the array and returned.
ko.extenders.defaultSort = function (target, sortExpression) {

    var expression = sortExpression;

    //it is an observable, the underlying value is an array, and it's not a computed observable
    if (ko.isObservable(target) && Array.isArray(target()) && ko.isComputed(target) == false) {

        //returns the sorted array and sorts the target, including the slice makes a copy of the array without affecting the target's array item order
        target.arraySorted = function () {
            return target.slice().sort(expression);
        }

    } else {
        console.log("defaultSort cannot be applied to target. defaultSort can only be applied to non-computed observable arrays.")
    }

}



//loops through all an objects properties recursively and runs the parse method on each prooperty
//skips all computed properties, since they will get recalculated if other observables change, no need to subscribe to them.
function setupAllObservabletProperties(obj, memberName, parse) {

    var computed = ko.isComputed(obj);

    //apply parse to main object
    if (computed == false) {
        //console.log("parsing " + memberName);
        parse(obj, memberName);
    }
    

    //if obj is observable, set itself to it's true value before proceeding
    if (ko.isObservable(obj)) {
        obj = obj();
    }

    
    if (obj instanceof Object == true && computed == false) {
        for (var member in obj) {
            setupAllObservabletProperties(obj[member], member, parse)
        }
    }
};


//deletes any ingoreDirty properties from the model before converting and saving
function processKoModelToJson(rootModel) {

    var clonedModel = deepCloneToJSWithIgnoresAndSorts(rootModel);

    var jsonModel = ko.toJSON(clonedModel);

    return jsonModel;

}
//used to clone the ko model and unwrap it while ignoring dirty properties as well as sort arrays to their default sorting.
//ignore functions and knockout computed properties
function deepCloneToJSWithIgnoresAndSorts(rootModel) {

    var model = rootModel;
    var rootIsObservable = ko.isObservable(rootModel);
    var rootIsComputed = ko.isComputed(rootModel);

    //if it's a computed, undefined, or null returned nothing
    //also if it's an observable and ignoringDirty is set to true return nothing
    if (model == undefined || model == null || rootIsComputed || (rootIsObservable && model.ignoringDirty != undefined && model.ignoringDirty instanceof Function == true && model.ignoringDirty() == true)) {
        return undefined;
    } 

    //if it's a non-computed observable, unwrap the value, if it has the default sort method set, set it to the unwrapped sorted version
    if (rootIsObservable == true) {
        if (Array.isArray(model()) && model.arraySorted != undefined && model.arraySorted instanceof Function == true) {
            model = model.arraySorted();
        } else {
            model = rootModel();
        }
    }

    //the model is an array, loop over it's elements
    if (Array.isArray(model)) {
        var newArray = [];

        for (var i = 0; i < model.length; i++) {
            var arrayRecord = model[i];

            var processedElement = deepCloneToJSWithIgnoresAndSorts(arrayRecord);
            if (processedElement != undefined) {
                newArray.push(processedElement);
            }
        }

        return newArray;
    }
    //its an onject so loop over all it's properties
    else if (model instanceof Object == true && model instanceof Function == false) {

        var newObject = {};
        for (var property in model) {
            var processedValue = deepCloneToJSWithIgnoresAndSorts(model[property]);
            if (processedValue != undefined) {
                newObject[property] = processedValue;
            }
        }

        return newObject;
    }
    //simple property so just remodel the unwrapped value
    else {
        return model;
    }

}

//stores the reference to the models being tracked by a key identifier so we don't need to know it on a per page basis
//allows for multiple models to be tracked on one page
var referencesToHookedUpModels = {};

//custom change methods to execute when the model(s) have or have no changed.
var modelHasChangesFunction = undefined;
var modelsHaveNoChangesFunction = undefined;
var koDirtyExtensionDebug = false;

var modelChangedFunction = function (identifier, currentModelJson, originalRootModelJson, memberThatChanged, newValue) {
    var hasChanges = false;

    //if there is a change in this model, we know at least one model globally tracked on the page has changes.
    if (currentModelJson != originalRootModelJson) {
        console.log(identifier + " has changed via " + memberThatChanged + " to value " + newValue);
        hasChanges = true;
    }
    //if this supplied model has no changes, need to check all others tracked on the page as well to make sure they also have no changes.
    else if (currentModelJson == originalRootModelJson) {
        console.log(identifier + " has reverted to original state.");

        hasChanges = checkAllModelsForChanges();
    }

    executeModelsChangedActions(hasChanges);
};

var executeModelsChangedActions = function (hasChanges, identifier, currentModelJson, originalRootModelJson, memberThatChanged, newValue) {
    //execute custom methods if they aren't set to undefined (they were set by calling the setChangeFunctions)
    if (hasChanges == true) {
        console.log("One or more models on the page has changes.")
        if (modelHasChangesFunction != undefined) {
            modelHasChangesFunction(identifier, currentModelJson, originalRootModelJson, memberThatChanged, newValue);
        }
    } else {
        console.log("All models on the page has no changes.")
        if (modelsHaveNoChangesFunction != undefined) {
            modelsHaveNoChangesFunction(identifier, currentModelJson, originalRootModelJson, memberThatChanged, newValue);
        }
    }
}

var checkAllModelsForChanges = function () {

    var hasChanges = false;
    for (var propIdentifier in referencesToHookedUpModels) {
        var processedModel = processKoModelToJson(referencesToHookedUpModels[propIdentifier]);
        var originalModel = originalRootKoModels[propIdentifier];
        if (processedModel != originalModel) {
            hasChanges = true;
            console.log(propIdentifier + " has changes.");
        } else {
            console.log(propIdentifier + " has no changes.");
        }
    }

    return hasChanges;
}

var KoIsDirtyExtension = {
    markEntirePageClean: function () {
        for (var identifier in referencesToHookedUpModels) {
            var model = referencesToHookedUpModels[identifier];
            originalRootKoModels[identifier] = processKoModelToJson(model);
        }

        executeModelsChangedActions(checkAllModelsForChanges());
    },
    markModelClean: function (identifier) {
        var modelReference = referencesToHookedUpModels[identifer];
        if (modelReference != null && modelReference != undefined) {
            originalRootKoModels[identifier] = processKoModelToJson(modelreference);
        }

        executeModelsChangedActions(checkAllModelsForChanges());
    },
    setDebug: function (debug) {
        koDirtyExtensionDebug = debug;
    },
    setChangeFunctions: function (ifModelHasChangesFunction, ifModelsHaveNoChangesFunction) {
        modelHasChangesFunction = ifModelHasChangesFunction;
        modelsHaveNoChangesFunction = ifModelsHaveNoChangesFunction;
    },
    setupKnockoutModel: function(knockoutRootModel, modelIdentifier) {

        referencesToHookedUpModels[modelIdentifier] = knockoutRootModel;
        originalRootKoModels[modelIdentifier] = processKoModelToJson(knockoutRootModel);

        setupAllObservabletProperties(
            knockoutRootModel,
            "RootModel",
            function (objValue, memberName) {
                if (ko.isObservable(objValue) == true && ko.isComputed(objValue) == false) {
                    var identifier = modelIdentifier;
                    if (objValue.ignoringDirty == undefined || (objValue.ignoringDirty instanceof Function && objValue.ignoringDirty() == false)) {
                        //console.log("Setting subscribe for " + memberName);
                        objValue.subscribe(function (newValue) {
                            modelChangedFunction(
                                identifier,
                                processKoModelToJson(referencesToHookedUpModels[identifier]),
                                originalRootKoModels[modelIdentifier],
                                memberName,
                                newValue);
                        });
                    }
                }
            }
        );
    }
}



